<script setup>
// import { computed } from "vue";
import { useRoute } from "vue-router";
// import { useStore } from "vuex";

import SidenavItem from "./SidenavItem.vue";
// import SidenavCard from "./SidenavCard.vue";

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};
</script>
<template>
  
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul style="list-style-type: none;">
      <li style="">
        <label for="example-text-input" class="form-control-label" style="font-size:15px">{{ model.user.name }}</label> 
      </li>
    </ul>
    <hr />
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          to="/dashboard-default"
          :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          :navText="'Dashboard'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="mt-3 nav-item">
        <h6
          v-on:click="hideShowNav('Customer',visibleCustomer)"
          class="text-xs ps-4 text-uppercase font-weight-bolder"
          :class="'ms-2'" style="width: 80%;cursor: pointer;"
        >
          Customer
          <span v-if="visibleCustomer">
            <font-awesome-icon icon="fa-solid fa-minus text-dark text-sm" style="color:red; float: right;" />
          </span>
          <span v-else>
            <font-awesome-icon icon="fa-solid fa-plus text-dark text-sm" style="color:green; float: right;" />
          </span>
        </h6>
      </li>
      <div v-show="visibleCustomer" class="navbar-nav">
        <!-- <li class="nav-item">
          <sidenav-item
            to="/users"
            :class="getRoute() === 'user' ? 'active' : ''"
            :navText="'Users'"
          >
            <template v-slot:icon>
              <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li> -->
        <li class="nav-item">
          <sidenav-item
            to="/customer"
            :class="getRoute() === 'customer' ? 'active' : ''"
            :navText="'Customer'"
          >
            <template v-slot:icon>
              <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
      </div>
      <li class="mt-3 nav-item">
        <h6
          v-on:click="hideShowNav('Sawit',visibleSawit)"
          class="text-xs ps-4 text-uppercase font-weight-bolder"
          :class="'ms-2'" style="width: 80%;;cursor: pointer;"
        >
          Sawit
          <span v-if="visibleSawit">
            <font-awesome-icon icon="fa-solid fa-minus text-dark text-sm" style="color:red; float: right;" />
          </span>
          <span v-else>
            <font-awesome-icon icon="fa-solid fa-plus text-dark text-sm" style="color:green; float: right;" />
          </span>
        </h6>
      </li>
      <div v-show="visibleSawit" class="navbar-nav">
        <li class="nav-item">
          <sidenav-item
            to="/block"
            :class="getRoute() === 'block' ? 'active' : ''"
            :navText="'Block'"
          >
            <template v-slot:icon>
              <i class="ni ni-square-pin text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/sawitbuah"
            :class="getRoute() === 'sawitbuah' ? 'active' : ''"
            :navText="'Sawit Buah'"
          >
            <template v-slot:icon>
              <font-awesome-icon icon="fa fa-list text-dark text-sm opacity-10" />
              
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/blockkerja"
            :class="getRoute() === 'blockkerja' ? 'active' : ''"
            :navText="'Block Kerja'"
          >
          <template v-slot:icon>
            <i class="text-dark text-sm opacity-10"><font-awesome-icon icon="fa fa-tasks " /></i>
              
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/sewapajak"
            :class="getRoute() === 'sewapajak' ? 'active' : ''"
            :navText="'Sewa Pajak'"
          >
            <template v-slot:icon>
              <font-awesome-icon icon="fa fa-money-bill text-dark text-sm opacity-10" />
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/blockaccount"
            :class="getRoute() === 'blockaccount' ? 'active' : ''"
            :navText="'Block Account'"
          >
            <template v-slot:icon>
              <i class="fa fa-dollar-sign text-dark text-sm opacity-10" ></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/bajareport"
            :class="getRoute() === 'bajareport' ? 'active' : ''"
            :navText="'Baja Report'"
          >
            <template v-slot:icon>
              <font-awesome-icon icon="fa fa-list text-dark text-sm opacity-10" />
            </template>
          </sidenav-item>
        </li>
      </div>
      
      <li class="mt-3 nav-item">
        <h6
          v-on:click="hideShowNav('Expenses',visibleExpenses)"
          class="text-xs ps-4 text-uppercase font-weight-bolder"
          :class="'ms-2'" style="width: 80%;cursor: pointer;"
        >
          Expenses
          <span v-if="visibleExpenses">
            <font-awesome-icon icon="fa-solid fa-minus text-dark text-sm" style="color:red; float: right;" />
          </span>
          <span v-else>
            <font-awesome-icon icon="fa-solid fa-plus text-dark text-sm" style="color:green; float: right;" />
          </span>
        </h6>
      </li>
      <div v-show="visibleExpenses" class="navbar-nav">
        <li class="nav-item">
          <sidenav-item
            to="/expenses"
            :class="getRoute() === 'expenses' ? 'active' : ''"
            :navText="'Expenses'"
          >
            <template v-slot:icon>
              <i class="fas fa-money-check-alt text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/expensesReport"
            :class="getRoute() === 'expensesReport' ? 'active' : ''"
            :navText="'Report'"
          >
            <template v-slot:icon>
              <i class="fas fa-file-alt text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
      </div>
      <li class="mt-3 nav-item">
        <h6
          v-on:click="hideShowNav('Order',visibleOrder)"
          class="text-xs ps-4 text-uppercase font-weight-bolder"
          :class="'ms-2'" style="width: 80%;;cursor: pointer;"
        >
          Orders
          <span v-if="visibleOrder">
            <font-awesome-icon icon="fa-solid fa-minus text-dark text-sm" style="color:red; float: right;" />
          </span>
          <span v-else>
            <font-awesome-icon icon="fa-solid fa-plus text-dark text-sm" style="color:green; float: right;" />
          </span>
        </h6>
      </li>
      <div v-show="visibleOrder" class="navbar-nav">
        <li class="nav-item">
          <sidenav-item
            to="/order"
            :class="getRoute() === 'order' ? 'active' : ''"
            :navText="'Create Order'"
          >
            <template v-slot:icon>
              <font-awesome-icon icon="fa-solid fa-cart-shopping text-dark text-sm opacity-10" />
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/orderlist"
            :class="getRoute() === 'orderlist' ? 'active' : ''"
            :navText="'Order List'"
          >
            <template v-slot:icon>
              <font-awesome-icon icon="fa-solid fa-list text-dark text-sm opacity-10" />
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/deliverylist"
            :class="getRoute() === 'deliverylist' ? 'active' : ''"
            :navText="'Delivery List'"
          >
            <template v-slot:icon>
              <font-awesome-icon icon="fa-solid fa-list text-dark text-sm opacity-10" />
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/product"
            :class="getRoute() === 'product' ? 'active' : ''"
            :navText="'Product'"
          >
            <template v-slot:icon>
              <font-awesome-icon icon="fa-solid fa-list text-dark text-sm opacity-10" />
            </template>
          </sidenav-item>
        </li>
      </div>
      <li class="mt-3 nav-item">
        <h6
          v-on:click="hideShowNav('Nursery',visibleNursery)"
          class="text-xs ps-4 text-uppercase font-weight-bolder"
          :class="'ms-2'" style="width: 80%;cursor: pointer;"
        >
          Nursery
          <span v-if="visibleNursery">
            <font-awesome-icon icon="fa-solid fa-minus text-dark text-sm" style="color:red; float: right;" />
          </span>
          <span v-else>
            <font-awesome-icon icon="fa-solid fa-plus text-dark text-sm" style="color:green; float: right;" />
          </span>
        </h6>
      </li>
      <div v-show="visibleNursery" class="navbar-nav">
        <li class="nav-item">
          <sidenav-item
            to="/gallery"
            :class="getRoute() === 'gallery' ? 'active' : ''"
            :navText="'Gallery & Prices'"
          >
            <template v-slot:icon>
              <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/batch"
            :class="getRoute() === 'batch' ? 'active' : ''"
            :navText="'Batch'"
          >
          
            <template v-slot:icon>
              <font-awesome-icon icon="fa-solid fa-seedling text-dark text-sm opacity-10"  />
              <!-- <i class="fa-solid fa-seedling text-dark text-sm opacity-10"></i> -->
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/batchstock"
            :class="getRoute() === 'batchstock' ? 'active' : ''"
            :navText="'Batch Stock'"
          >
          
            <template v-slot:icon>
              <font-awesome-icon icon="fa-solid fa-box text-dark text-sm opacity-10"  />
              <!-- <i class="fa-solid fa-seedling text-dark text-sm opacity-10"></i> -->
            </template>
          </sidenav-item>
        </li>
      </div>
      <li class="mt-3 nav-item">
        <h6
          v-on:click="hideShowNav('Payroll',visiblePayroll)"
          class="text-xs ps-4 text-uppercase font-weight-bolder"
          :class="'ms-2'" style="width: 80%;cursor: pointer;"
        >
          Payroll
          <span v-if="visiblePayroll">
            <font-awesome-icon icon="fa-solid fa-minus text-dark text-sm" style="color:red; float: right;" />
          </span>
          <span v-else>
            <font-awesome-icon icon="fa-solid fa-plus text-dark text-sm" style="color:green; float: right;" />
          </span>
        </h6>
      </li>
      <div v-show="visiblePayroll" class="navbar-nav">
        <li class="nav-item">
          <sidenav-item
            to="/employee"
            :class="getRoute() === 'employee' ? 'active' : ''"
            :navText="'Employee'"
          >
            <template v-slot:icon>
              <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/salary"
            :class="getRoute() === 'salary' ? 'active' : ''"
            :navText="'Salary'"
          >
          
            <template v-slot:icon>
              <font-awesome-icon icon="	fas fa-dollar-sign text-dark text-sm opacity-10"  />
              <!-- <i class="fa-solid fa-seedling text-dark text-sm opacity-10"></i> -->
            </template>
          </sidenav-item>
        </li>
      </div>
      <li class="mt-3 nav-item">
        <h6
          v-on:click="hideShowNav('Stock',visibleStock)"
          class="text-xs ps-4 text-uppercase font-weight-bolder"
          :class="'ms-2'" style="width: 80%;cursor: pointer;"
        >
          Stock
          <span v-if="visibleStock">
            <font-awesome-icon icon="fa-solid fa-minus text-dark text-sm" style="color:red; float: right;" />
          </span>
          <span v-else>
            <font-awesome-icon icon="fa-solid fa-plus text-dark text-sm" style="color:green; float: right;" />
          </span>
        </h6>
      </li>
      <div v-show="visibleStock" class="navbar-nav">
        <li class="nav-item">
          <sidenav-item
            to="/StockProfile"
            :class="getRoute() === 'StockProfile' ? 'active' : ''"
            :navText="'Stock Profile'"
          >
            <template v-slot:icon>
              <i class="fa fa-list text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/stock"
            :class="getRoute() === 'stock' ? 'active' : ''"
            :navText="'Stock In/Out'"
          >
            <template v-slot:icon>
              <i class="fas fa-box text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
      </div>
      <li class="mt-3 nav-item">
        <h6
          v-on:click="hideShowNav('Vehicle',visibleVehicle)"
          class="text-xs ps-4 text-uppercase font-weight-bolder"
          :class="'ms-2'" style="width: 80%;;cursor: pointer;"
        >
          Vehicle
          <span v-if="visibleVehicle">
            <font-awesome-icon icon="fa-solid fa-minus text-dark text-sm" style="color:red; float: right;" />
          </span>
          <span v-else>
            <font-awesome-icon icon="fa-solid fa-plus text-dark text-sm" style="color:green; float: right;" />
          </span>
        </h6>
      </li>
      <div v-show="visibleVehicle" class="navbar-nav">
        <li class="nav-item">
          <sidenav-item
            to="/vehicle"
            :class="getRoute() === 'vehicle' ? 'active' : ''"
            :navText="'Vehicle'"
          >
            <template v-slot:icon>
              <font-awesome-icon icon="fa-solid fa-truck text-dark text-sm opacity-10" />
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/lorryservices"
            :class="getRoute() === 'lorryservices' ? 'active' : ''"
            :navText="'Services'"
          >
            <template v-slot:icon>
              <font-awesome-icon icon="fa-solid fa-truck text-dark text-sm opacity-10" />
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/lorrycostkm"
            :class="getRoute() === 'lorrycostkm' ? 'active' : ''"
            :navText="'Cost/KM'"
          >
            <template v-slot:icon>
              <font-awesome-icon icon="fa-solid fa-dollar-sign text-dark text-sm opacity-10" />
            </template>
          </sidenav-item>
        </li>
      </div>
      <!-- <li class="mt-3 nav-item">
        <h6
          v-on:click="hideShowNav('Dani',visibleDani)"
          class="text-xs ps-4 text-uppercase font-weight-bolder"
          :class="'ms-2'" style="width: 80%;cursor: pointer;"
        >
          Dani Getah
          <span v-if="visibleDani">
            <font-awesome-icon icon="fa-solid fa-minus text-dark text-sm" style="color:red; float: right;" />
          </span>
          <span v-else>
            <font-awesome-icon icon="fa-solid fa-plus text-dark text-sm" style="color:green; float: right;" />
          </span>
        </h6>
      </li> -->
      <div v-show="visibleDani" class="navbar-nav">
        <li class="nav-item">
          <sidenav-item
            to="/DaniBarang"
            :class="getRoute() === 'baranggetah' ? 'active' : ''"
            :navText="'Barang-barang'"
          >
            <template v-slot:icon>
              <i class="fas fa-box text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/Getah"
            :class="getRoute() === 'getahdetails' ? 'active' : ''"
            :navText="'Getah Details'"
          >
            <template v-slot:icon>
              <i class="fas fa-seedling text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/Pinjaman"
            :class="getRoute() === 'pinjamangetah' ? 'active' : ''"
            :navText="'Pinjaman'"
          >
            <template v-slot:icon>
              <i class="fas fa-dollar-sign text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
      </div>
      <hr />
      <li class="nav-item">
        <sidenav-item
          to="tender"
          :class="getRoute() === 'tender' ? 'active' : ''"
          :navText="'Tender'"
        >
          <template v-slot:icon>
            <i class="fa fa-file text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <!-- <li class="mt-3 nav-item" v-on:click="hideShowNav('Loan',visibleLoan)">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder"
          :class="'ms-2'" style="width: 80%;;cursor: pointer;"
        >
          Sewa/Loan
          <span v-if="visibleLoan">
            <font-awesome-icon icon="fa-solid fa-minus text-dark text-sm" style="color:red; float: right;" />
          </span>
          <span v-else>
            <font-awesome-icon icon="fa-solid fa-plus text-dark text-sm" style="color:green; float: right;" />
          </span>
        </h6>
      </li> -->
      <div v-show="visibleLoan" class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          to="sewa"
          :class="getRoute() === 'sewa' ? 'active' : ''"
          :navText="'Sewa'"
        >
          <template v-slot:icon>
            <font-awesome-icon icon="fa-solid fa-dollar-sign text-dark text-sm opacity-10" />
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          to="loan"
          :class="getRoute() === 'loan' ? 'active' : ''"
          :navText="'Loan'"
        >
          <template v-slot:icon>
            <font-awesome-icon icon="fa-solid fa-dollar-sign text-dark text-sm opacity-10" />
          </template>
        </sidenav-item>
      </li>
      
      </div>
      <li class="mt-3 nav-item" v-on:click="hideShowNav('Reports',visibleReports)">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder"
          :class="'ms-2'" style="width: 80%;;cursor: pointer;"
        >
          Reports
          <span v-if="visibleLoan">
            <font-awesome-icon icon="fa-solid fa-minus text-dark text-sm" style="color:red; float: right;" />
          </span>
          <span v-else>
            <font-awesome-icon icon="fa-solid fa-plus text-dark text-sm" style="color:green; float: right;" />
          </span>
        </h6>
      </li>
      <div v-show="visibleReports" class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          to="/vehiclereports"
          :class="getRoute() === 'vehiclereports' ? 'active' : ''"
          :navText="'Vehicle'"
        >
          <template v-slot:icon>
            <font-awesome-icon icon="fa-solid fa-truck text-dark text-sm opacity-10" />
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          to="/loan"
          :class="getRoute() === 'loan' ? 'active' : ''"
          :navText="'Loan'"
        >
          <template v-slot:icon>
            <font-awesome-icon icon="fa-solid fa-dollar-sign text-dark text-sm opacity-10" />
          </template>
        </sidenav-item>
      </li>
      
      </div>
    </ul>
  </div>

</template>


<script>
import axios from 'axios';

export default {
  name:'authUser',
  data(){
    return {
      visibleLoan: false,
      visibleVehicle: false,
      visibleSawit: false,
      visibleCustomer: false,
      visibleOrder: false,
      visibleNursery:false,
      visibleStock: false,
      visibleReports:false,
      visiblePayroll:false,
      visibleDani:false,
      visibleExpenses:false,
      model:{
        user:{
            id:'',
            username:'',
            created_at:'',
            updated_at:'',
            isdelete:'',
            name:''
        },
      }
    }
  },
  mounted(){
    // this.model.block.blockid = this.$route.params.id;
    this.getAuthUser();
  },
  methods: {
    hideShowNav(nav, visible){
      this.visibleLoan= false;
      this.visibleVehicle= false;
      this.visibleSawit= false;
      this.visibleCustomer= false;
      this.visibleOrder= false;
      this.visibleNursery = false;
      this.visibleStock = false;
      this.visibleReports = false;
      this.visiblePayroll = false;
      this.visibleDani = false;
      this.visibleExpenses = false;
      if(nav == "Loan"){
        this.visibleLoan = !visible;
      }else if(nav == "Customer"){
        this.visibleCustomer = !visible;
      }else if(nav == "Vehicle"){
        this.visibleVehicle = !visible;
      }else if(nav == "Sawit"){
        this.visibleSawit = !visible;
      }else if(nav == "Order"){
        this.visibleOrder = !visible;
      }else if(nav == "Nursery"){
        this.visibleNursery = !visible;
      }else if(nav == "Stock"){
        this.visibleStock = !visible;
      }else if(nav == "Reports"){
        this.visibleReports = !visible;
      }else if(nav == "Payroll"){
        this.visiblePayroll = !visible;
      }else if(nav == "Dani"){
        this.visibleDani = !visible;
      }else if(nav == "Expenses"){
        this.visibleExpenses = !visible;
      }
    },
    getAuthUser(){
        // var mythis = this;
        axios.get('user/user')
            .then(res => {
              // console.log(res.data);
              this.model.user = res.data;
              localStorage.setItem('userId', res.data.id);
              localStorage.setItem('username', res.data.username);
              localStorage.setItem('name', res.data.name);
            }).catch(function (error){
                if(error.message == 'Unauthenticated.'){
                  alert('User Unauthenticated.Please login! ');
                }else{
                    console.log('Error',error.message);
                }
            });
    }
    
  },
}
</script>